module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/artillery-strike.6fad6c68.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/artillery-strike.png
// module id = 3733
// module chunks = 11